// extracted by mini-css-extract-plugin
module.exports = {"dialog":"AlertModal_dialog__3Nsyr","footer":"AlertModal_footer__3l7XY","content":"AlertModal_content__3fgRR","contactSupport":"AlertModal_contactSupport__D02tY"};